/* eslint-disable react/no-array-index-key */
import { Box, Divider } from '@material-ui/core';
import React, { FC, ReactElement } from 'react';
import { defaultTreetStyles } from '../../shopConfig/config';
import css from './FormOptionsTable.module.css';

interface OptionsTablePropsType {
  containerId: string;
  fieldError?: any;
  children: ReactElement[];
}

const FormOptionsTable: FC<OptionsTablePropsType> = (props) => {
  const { children, containerId, fieldError } = props;

  return (
    <Box
      id={containerId}
      display="flex"
      flexDirection="column"
      maxWidth="540px"
      style={{
        border: `1px solid ${fieldError ? defaultTreetStyles.red80 : defaultTreetStyles.gray60}`,
        backgroundColor: defaultTreetStyles.gray10,
      }}
    >
      <fieldset className={css.fieldGroup}>
        {children?.map((child, index) => (
          <React.Fragment key={`${child.key}-container`}>
            <ul className={css.list}>
              <li>
                <Box mx={3}>{child}</Box>
              </li>
            </ul>
            {index !== children.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </fieldset>
    </Box>
  );
};

export default FormOptionsTable;
